module.exports = __webpack_public_path__ + "img/engagement_pic.21eb89cb.jpg";